import { render, staticRenderFns } from "./vc-panel.vue?vue&type=template&id=60d9bceb&scoped=true&"
import script from "./vc-panel.vue?vue&type=script&lang=js&"
export * from "./vc-panel.vue?vue&type=script&lang=js&"
import style0 from "./vc-panel.vue?vue&type=style&index=0&id=60d9bceb&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d9bceb",
  null
  
)

export default component.exports